import Swiper, { Navigation, EffectFade } from 'swiper';
//import 'swiper/css';

(function () {
  /* Variables placed inside of this function will be considered private */
  Swiper.use([Navigation, EffectFade]);
  /* You won't see privateVar in global scope */
  const swipers = document.querySelectorAll('.swiper');

  swipers.forEach((s) => {
    let swp;
    if (s.dataset.full) {
      swp = new Swiper(s, {
        slidesPerView: 'auto',
        effect: 'fade',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    } else {
      swp = new Swiper(s, {
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
          '@0.00': {
            slidesPerView: 1.5,
          },
          '@0.75': {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          '@1.25': {
            slidesPerView: 3.5,
            spaceBetween: 28,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }

    // Check if it has custom nav
    if (s.dataset.customNav) {
      let customNav = document.querySelector(`#${s.dataset.customNav}`);
      let links = customNav.querySelectorAll('[data-nav-link]');
      var slides = s.querySelectorAll('.swiper-slide');
      var slideArray = Array.prototype.slice.call(slides);
      // code to assign dynamic id to swiper
      links.forEach((l, i) => {
        for (i = 0; i < slideArray.length; i++) {
          if (
            slideArray[i].dataset.customNavSlide ==
            l.getAttribute('href').replace('#', '')
          ) {
            slideArray[i].id = l.getAttribute('href').slice(1);
            swp.slideTo(i);
            return;
          }
        }
      });
      links.forEach((l, i) => {
        l.onclick = (e) => {
          e.preventDefault();

          // get the slide index by using data-custom-nav-slide
          //data-custom-nav-slideco
          for (i = 0; i < slideArray.length; i++) {
            if (
              slideArray[i].dataset.customNavSlide ==
              l.getAttribute('href').replace('#', '')
            ) {
              swp.slideTo(i);
              return;
            }
          }
        };
      });

      // show swiper on location based
      let fetchIp = fetch('https://ipecho.net/plain');
      fetchIp
        .then((res) => res.text())
        .then((ip) => {
          let fetchCity = fetch('/ipinfo.php?ip=' + ip);
          fetchCity
            .then((res) => res.text())
            .then((data) => {
              let currentCity = data;
              let links = document.querySelectorAll('[data-nav-link]');
              links.forEach((city, i) => {
                if (city.text.trim() == currentCity) {
                  city.click();
                }
              });
            })
            .then((response) => {
              /* show swiper on location based on language based */
              let countryJson = [
                {
                  name: 'pune',
                  code: 'en-in',
                },
                {
                  name: 'london',
                  code: 'en-gb',
                },
                {
                  name: 'newyork',
                  code: 'en-us',
                },
                {
                  name: 'amsterdam',
                  code: 'nl-nl',
                },
                {
                  name: 'serbia',
                  code: 'en-rs',
                },
                {
                  name: 'melbourne',
                  code: 'en-au',
                },
                {
                  name: 'toronto',
                  code: 'en-ca',
                },
                {
                  name: 'singapore',
                  code: 'en-sg',
                },
                {
                  name: 'dubai',
                  code: 'en-ae',
                },
                {
                  name: 'hongkong',
                  code: 'en-hk',
                },
                {
                  name: 'tokyo',
                  code: 'en-jp',
                },
              ];
              let language = window.location.pathname.split('/')[1];

              for (let i = 0; i < slideArray.length; i++) {
                countryJson.forEach((country) => {
                  if (
                    slideArray[i].dataset.customNavSlide == country.name &&
                    language == country.code
                  ) {
                    swp.slideTo(i);
                    return;
                  }
                });
              }
            })
            .then((response) => {
              /* show swiper on location based on language based */
              let path = window.location.href.split('#')[1];

              if (path) {
                links.forEach((l, i) => {
                  for (i = 0; i < slideArray.length; i++) {
                    if (slideArray[i].dataset.customNavSlide == path) {
                      swp.slideTo(i);
                      return;
                    }
                  }
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })

        .catch((error) => {
          console.log(error);
        });

      //section used for small screen Dropdown
      const selectOurWorkPlace = document.querySelector('#OurWorkPlaceCat');
      if (selectOurWorkPlace) {
        selectOurWorkPlace.addEventListener('change', (e) => {
          let linkOurWorkPlace = e.target.value;
          for (var i = 0; i < slideArray.length; i++) {
            if (slideArray[i].dataset.customNavSlide == linkOurWorkPlace) {
              swp.slideTo(i);
              return;
            }
          }
        });
      }
    }
  });
})();
